import { render, staticRenderFns } from "./BlockPromoEvent.vue?vue&type=template&id=b491ad18&"
import script from "./BlockPromoEvent.vue?vue&type=script&lang=js&"
export * from "./BlockPromoEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports